import { determineEventMode, type EventMode, type EventWindows } from "@verity-connect/domain";

export type ConventionPhase = "before" | "during" | "between" | "after";

export function participantEventMode(
  lifecycleNow: Date,
  windows: EventWindows | null,
  phase: ConventionPhase,
): EventMode {
  return windows ? determineEventMode(lifecycleNow, windows)
    : phase === "during" || phase === "between" ? "active" : phase === "after" ? "follow-through" : "preparation";
}

export function isPersonalRoute(pathname: string): boolean {
  return pathname === "/home" || pathname === "/messages" || pathname === "/events"
    || pathname === "/records" || pathname.startsWith("/records/") || pathname === "/account";
}

export function usesPersonalNavigation(signedIn: boolean, mode: EventMode, pathname: string): boolean {
  const conventionOwnsTheEntrance = mode === "preparation" || mode === "active";
  return signedIn && (!conventionOwnsTheEntrance || isPersonalRoute(pathname));
}
